/**
 * Returns true if largeArray has more items than smallArray
 * Returns false otherwise
 *
 * @param {Array} largeArray
 * @param {Array} smallArray
 * @returns {Boolean} whether largeArray has more items than smallArray
 */
export const hasMoreItems = (largeArray, smallArray) => {
  if (!Array.isArray(largeArray) || !Array.isArray(smallArray)) return false;
  return (largeArray.length > smallArray.length);
};
